import Slider from "react-slick";
import Layout from "../../components/layout";
import useFetch from "../../utils/useFetch";

const Gallery = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
  };

  const { data: slides } = useFetch<any[]>("gallery");

  return (
    <Layout>
      <section className='container mx-auto '>
        <div className='border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            گالری تصاویر
          </div>
          <div className='p-4'>
            <Slider {...settings}>
              {slides &&
                slides?.map((slide) => (
                  <div>
                    <img
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                        display: "block",
                      }}
                      alt={slide}
                      src={"http://app.tiarafood.ir/img/" + slide}
                    />
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Gallery;
